<template>
  <div class="container-fluid m-0 p-0" id="mip">
    <MatrizMenu />
    <div class="pl-2 pr-2">
      <div class="bg-light matriz-peligro-content col-md-12">
        <div class="collapse show" id="mip-collapse">
          <div class="encabezado" v-show="!$store.state.global_id_matriz_riesgo">
            <h5 class="color_letra--encabezado">Contenido No Disponible</h5>
            <div class="dropdown">
              <span class="badge text-secondary dropbtn"><i class="fas fa-question-circle fa-lg"></i></span>
              <div class="dropdown_content">
                <p>
                  En este momento usted no tiene un Centro de Trabajo
                  seleccionado o no está con un peligro específico
                </p>
                <p>
                  Para seleccionar un Centro de Trabajo diríjase a la sección
                  <b>Lista Centro de Trabajo</b>, opciones del Centro de
                  Trabajo, <b>Editar</b>
                </p>
                <p>
                  Para seleccionar un peligro específico, en este mismo módulo,
                  en opciones de la lista de matrices peligro, <b>Editar</b>
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <form v-on:submit.prevent="accion_formulario()" class="col-md-12 mt-3">
              <div class="row justify-content-center ">
                <div class="col-md-3">
                  <label class="color_letra text-lg-left">Peligro: *
                    <span class="badge text-secondary">
                      <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                        data-html="true"
                        title="Fuente, situación o acto con potencial de daños en términos de enfermedad o lesión a las personas, o una combinación de estos.">
                      </i>
                    </span>
                  </label>
                  <select class="boton_texto form-control form-control-sm" v-model="clasificacion_peligro"
                    @change="consultar_peligro()" required title="Seleccione una clasificación...">
                    <option value="" disabled selected>Seleccione</option>
                    <option v-for="(peligro, index) of peligros" :key="index.peligros">
                      {{ peligro }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="color_letra text-lg-left">Subclasificación: *
                    <span class="badge text-secondary"> </span>
                  </label>
                  <select v-model="subcla_selec" class="form-control form-control-sm boton_texto"
                    @change="consultar_subclasificacion()" required>
                    <option value="">Seleccione</option>
                    <option v-for="(subcla, index) of subclasificacion" :key="index.subclasificacion">
                      {{ subcla }}
                    </option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="color_letra text-lg-left">Descripción:*
                    <span class="badge text-secondary"> </span>
                  </label>
                  <textarea v-model="descripcion" class="form-control form-control-sm boton_texto"
                    placeholder="Descripción del peligro." autocomplete="on" spellcheck="true"></textarea>
                </div>

                <!-- NÚMERO DE EXPUESTOS -->
                <!-- N° CONDICIONAR QUE SEA <= QUE EL INGRESADO EN EL REGISTRO CENTRO DE TRABAJO -->
                <div class="col-md-4">
                  <br />
                  <label class="color_letra text-lg-left">N° Expuestos (menor o igual a
                    {{ $store.state.n_max_expuestos }}): *
                    <span class="badge text-secondary">
                      <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                        data-html="true" title="Deber ser menor al número asignado al centro de trabajo.">
                      </i>
                    </span>
                  </label>
                  <input type="number" v-model="c_num_expuestos" class="boton_texto form-control form-control-sm"
                    id="expuestos" min="1" :max="$store.state.n_max_expuestos" required />
                </div>
                <div class="col-md-5">
                  <br />
                  <label class="color_letra">Efectos Posibles: *
                    <span class="badge text-secondary">
                      <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                        data-html="true"
                        title="Efectos posibles de los peligros sobre la integridad o salud de los trabajadores.">
                      </i>
                    </span> </label><br />
                  <multiselect class="form-control form-control-sm boton_texto" v-model="check_efecto_posible"
                    tag-placeholder="Agregar nuevo Efecto Posible" placeholder="Buscar o agregar un efecto posible"
                    :options="e_efecto_posible" deselectLabel="Enter para quitar" selectedLabel="Seleccionado"
                    selectLabel="Agregar" :multiple="true" :taggable="true" :limit="2" @tag="agregar_nuevo_efecto"
                    :close-on-select="false" :clear-on-select="false" :preserve-search="true" :preselect-first="true"
                    :spellcheck="true">
                  </multiselect>
                </div>

                <!-- PEOR CONSECUENCIA -->
                <div class="col-md-3">
                  <br />
                  <label class="color_letra">Peor Consecuencia: *
                    <span class="badge text-secondary">
                      <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                        data-html="true"
                        title="De los peores efectos posibles identificados, señale la peor consecuencia; hacia esta deben dirigirse las medidas de intervención.">
                      </i>
                    </span>
                  </label>
                  <select id="select_consecuencia" v-model="c_peor_consecuencia"
                    class="form-control form-control-sm boton_texto">
                    <option disabled value="" selected>
                      Seleccione uno...
                    </option>
                    <option v-for="efecto in check_efecto_posible" :key="efecto.check_efecto_posible">
                      {{ efecto }}
                    </option>
                  </select>
                </div>

                <div class="col-md-3">
                  <br />
                  <label class="color_letra">Control Fuente: *
                    <span class="badge text-secondary">
                      <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                        data-html="true" title="Controles Existentes Fuente">
                      </i>
                    </span> </label><br />
                  <multiselect class="form-control form-control-sm boton_texto" v-model="select_fuente"
                    :options="control_fuente" tag-placeholder="Agregar nuevo Control Fuente"
                    placeholder="Buscar o agregar" deselectLabel="Enter para quitar" selectedLabel="Seleccionado"
                    selectLabel="Agregar" :multiple="true" :taggable="true" :limit="2" @tag="agregar_fuente"
                    :close-on-select="false" :clear-on-select="false" :preserve-search="true" :preselect-first="true"
                    :spellcheck="true">
                  </multiselect>
                </div>
                <div class="col-md-3">
                  <br />
                  <label class="color_letra">Control Medio: *
                    <span class="badge text-secondary">
                      <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                        data-html="true" title="Controles Existentes Medio">
                      </i>
                    </span> </label><br />
                  <multiselect class="form-control form-control-sm boton_texto" v-model="select_medio"
                    :options="control_medio" tag-placeholder="Agregar nuevo Control Medio" placeholder="Buscar o agregar"
                    deselectLabel="Enter para quitar" selectedLabel="Seleccionado" selectLabel="Agregar" :multiple="true"
                    :taggable="true" :limit="2" @tag="agregar_medio" :close-on-select="false" :clear-on-select="false"
                    :preserve-search="true" :preselect-first="true" :spellcheck="true">
                  </multiselect>
                </div>
                <div class="col-md-3">
                  <br />
                  <label class="color_letra">Control Individuo: *
                    <span class="badge text-secondary">
                      <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                        data-html="true" title="Controles Existentes Individuo">
                      </i>
                    </span> </label><br />
                  <multiselect class="form-control form-control-sm boton_texto" v-model="select_individuo"
                    :options="control_individuo" tag-placeholder="Agregar nuevo Control Individuo"
                    placeholder="Buscar o agregar" deselectLabel="Enter para quitar" selectedLabel="Seleccionado"
                    selectLabel="Agregar" :multiple="true" :taggable="true" :limit="2" @tag="agregar_individuo"
                    :close-on-select="false" :clear-on-select="false" :preserve-search="true" :preselect-first="true"
                    :spellcheck="true">
                  </multiselect>
                </div>
                <div class="col-md-3">
                  <br />
                  <label class="color_letra">Antecedentes de ATEL: *
                    <span class="badge text-secondary">
                      <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                        data-html="true"
                        title="Seleccione a continuación si el peligro que está actualmente registrado ha ocasionado en el centro de trabajo accidente de trabajo y/o enfermedad laboral">
                      </i>
                    </span>
                  </label>
                  <select v-model="antecedente" class="form-control form-control-sm boton_texto" required>
                    <option disabled value="" selected>
                      Seleccione Antecedente
                    </option>
                    <option value="Ninguno">Ninguno</option>
                    <option value="Leve">Accidente de trabajo leve</option>
                    <option value="Grave">Accidente de trabajo grave</option>
                    <option value="Letalidad">
                      Accidente de trabajo con fatalidad
                    </option>
                    <option value="Declarada">
                      Enfermedad laboral declarada
                    </option>
                  </select>
                </div>
                <div class="col-md-3">
                  <br />
                  <label class="color_letra">Requisito legal: *
                    <span class="badge text-secondary">
                      <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                        data-html="true" title="">
                      </i>
                    </span>
                  </label>
                  <select v-model="requisito_legal" class="form-control form-control-sm boton_texto" required>
                    <option value="true">Sí</option>
                    <option value="false">No</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <br />
                  <label class="color_letra text-lg-left">Registro Fotográfico:
                    <span class="badge text-secondary">
                      <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                        data-html="true" title="">
                      </i>
                    </span>
                  </label>
                  <div class="row">
                    <div class="col-6">
                      <input type="file" v-on:change="base64Imagen1($event.target.files[0])" accept="/*image"
                        class="form-control form-control-sm boton_texto" id="img_peligro" />
                    </div>
                    <div class="col-6">
                      <input type="file" v-on:change="base64Imagen2($event.target.files[0])" accept="/*image"
                        class="form-control form-control-sm boton_texto" id="img_peligro2" /><br />
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div>
                <label class="color_letra mt-3">* Campos Obligatorios.</label>
              </div>
              <div class="row justify-content-center">
                <button v-show="$store.state.msp_c_key" type="button" @click="terminar_centro_trabajo()"
                  class="btn btn-sm btn-form font-weight-bold">
                  TERMINAR MATRIZ DE PELIGROS
                </button>
                <button v-show="$store.state.global_id_matriz_riesgo" type="button" @click="es_guardar = false; accion_formulario();"
                  class="btn btn-sm btn-form font-weight-bold">
                  TERMINAR
                </button>
                <button v-if="$store.state.global_id_matriz_riesgo &&
                  $store.state.global_privilegio_matriz_peligro.crear
                  " type="submit" @click="
    es_guardar = true;
  siguiente_peligro = true;
  " class="btn btn-sm btn-form font-weight-bold">
                  SIGUIENTE PELIGRO
                </button>
                <button type="submit" @click="es_guardar = true" class="btn btn-sm btn-form font-weight-bold"
                  :disabled="!$store.state.global_id_matriz_riesgo">
                  GUARDAR
                </button>
              </div>
            </form>
          </div>
        </div>
        <div class="d-flex justify-content-end m-0 p-0">
          <a @click="collapsed = !collapsed" class="pb-0 mb-0" data-toggle="collapse" data-target="#mip-collapse"
            aria-expanded="false" aria-controls="collapseExample">
            <i :class="[collapsed ? 'fa-chevron-up' : 'fa-chevron-down', 'fa']"></i>
          </a>
        </div>
      </div>
    </div>

    <!-- MODAL RIESGOS -->
    <div class="container">
      <div class="modal fade" id="modal_efectos_posibles" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h1 class="letra-sm-modal">
                <b>{{ nombre_efecto_posible }}</b>
              </h1>
              <br />
              <div class="row justify-content-center">
                <div class="col-10 mb-4">
                  <label class="typo__label">Seleccione Controles</label>
                  <multiselect v-model="check_efecto_posible" :options="e_efecto_posible" :multiple="true"
                    :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                    placeholder="Seleccionar para agregar" :preselect-first="true">
                    <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single"
                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Seleccionados</span></template>
                  </multiselect>
                </div>
                <div class="col-10 mb-4">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="todo" v-model="selectTodo" />
                    <label class="form-check-label">Seleccionar Todos</label>
                  </div>
                </div>
                <div class="col-10">
                  <textarea value="" v-model="efecto_posible_descripcion"
                    class="form-control form-control-sm boton_texto mb-3" placeholder="Otro Efecto" autocomplete="on"
                    onfocus="this.value=''"></textarea>
                  <div class="row justify-content-center">
                    <button @click="agregar_nuevo_efecto()" type="button" class="btn boton_guardar">
                      Nuevo Efecto
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
              <canvas id="canvas" width="100%" height="100%"></canvas>
          </div>
        </div>
      </div>
    </div>
    <Mtm />
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "./../firebase";
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import MatrizMenu from "@/components/MatrizMenu.vue";
import Mtm from "@/components/Mtm.vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "mip",
  components: {
    MatrizMenu,
    Mtm,
  },

  data() {
    return {
      collapsed: true,
      fecha_actual: "",
      id_matriz: "",

      // VARIABLES REGISTRO MATRIZ DE PELIGRO
      clasificacion_peligro: "",
      subcla_selec: "",
      descripcion: "",
      antecedente: "",
      requisito_legal: "",

      // VARIABLES PARA CARGAR PELIGROS
      peligros: [],
      subclasificacion: [],
      p_id_peligro: "",
      p_id_subcla: "",

      // VARIABLES PARA LOS MODALES FUENTE - MEDIO - INDIVIDUO
      fuente_descripcion: "",
      medio_descripcion: "",
      individuo_descripcion: "",

      // NUEVOS ARRAYS FUENTE - MEDIO - INDIVIDUO
      control_fuente: [],
      control_medio: [],
      control_individuo: [],

      select_fuente: [],
      select_medio: [],
      select_individuo: [],

      // EFECTOS POSIBLES
      id_efectos_posibles: "",
      e_efecto_posible: [],
      nombre_efecto_posible: "",
      efecto_posible_descripcion: "",
      check_efecto_posible: [],

      e_registrado_por: "",

      // BASE 64
      img_peligro: "",
      img_peligro2: "",

      c_num_expuestos: null,
      msg_expuestos: "",
      validador_expuestos: true,
      c_peor_consecuencia: "",

      es_guardar: false,
      siguiente_peligro: false,
    };
  },

  watch: {
    c_num_expuestos(value) {
      this.validador_num_expuestos(value);
    },
  },

  created() {
   this.irArriba();
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.img_peligro = [];
    this.img_peligro2 = [];
    if (this.$store.state.msp_c_key) {
      this.cargar_peligros();
    }
    if (
      this.$store.state.msp_c_key &&
      this.$store.state.global_id_matriz_riesgo
    ) {
      if (!this.$store.state.global_nuevo_peligro) {
        const docRef = db
          .collection("matriz_riesgo")
          .doc(this.$store.state.global_id_matriz_riesgo);
        docRef
          .get()
          .then((doc) => {
            this.id_efectos_posibles = doc.data().em_id_efectos_posibles;
            this.p_id_peligro = doc.data().em_id_peligro;
            this.clasificacion_peligro = doc.data().em_clasificacion;
            this.p_id_subcla = doc.data().em_id_subclasificacion;
            this.subcla_selec = doc.data().em_tipo;

            this.descripcion = doc.data().em_descripcion;
            this.check_efecto_posible = doc.data().em_efecto_posible;
            // this.control_fuente.push(doc.data().em_efecto_posible);

            this.select_fuente = doc.data().em_c_fuente;
            this.select_medio = doc.data().em_c_medio;
            this.select_individuo = doc.data().em_c_individuo;
            this.antecedente = doc.data().em_antecedente;
            this.requisito_legal = "";
            let em_requisito_legal = doc.data().em_requisito_legal;
            if (em_requisito_legal === false) {
              this.requisito_legal = "false";
            } else if (em_requisito_legal === true) {
              this.requisito_legal = "true";
            }
            this.img_peligro = doc.data().em_img_peligro;
            this.img_peligro2 = doc.data().em_img_peligro2;

            this.c_num_expuestos = doc.data().em_num_expuestos;
            this.c_peor_consecuencia = doc.data().em_peor_consecuencia;

            this.cargar_subclasificacion(this.p_id_peligro);
            this.consultar_subclasificacion();
          })
          .catch((error) => {
            console.log(
              "Error obteniendo el documento para ser editado:",
              error
            );
          });
      }
    }

    this.fecha_hoy();
    var today = new Date();
    var dd = today.getDate();

    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + yyyy;
  },

  methods: {
    irArriba(){
      console.log('entro aqui, ojala funcione');
      $('body,html').animate({ scrollTop:'0px' });
    },
    limpiar_variables_globales_terminar() {
      this.$store.state.mip_id_proceso = "";
      this.$store.state.mip_id_zona = "";
      this.$store.state.mip_id_actividad = "";
      this.$store.state.mip_id_tareas = "";
      this.$store.state.mip_proceso = "";
      this.$store.state.mip_zona = "";
      this.$store.state.mip_actividad = "";
      this.$store.state.mip_tarea = [];
      this.$store.state.mip_rutinario = "";
      this.$store.state.global_id_matriz_riesgo = "";
      this.$store.state.global_es_editar = false;
      this.$store.state.global_nuevo_peligro = false;
      this.$store.state.msp_c_key = "";
    },

    terminar_centro_trabajo() {
      NProgress.start();
      this.limpiar_variables();
      this.$store.commit("mutation_limpiar_globales");
      NProgress.done();
      NProgress.remove();
    },

    validador_num_expuestos(value) {
      this.c_num_expuestos = value;
      this.msg_expuestos = "";
      if (value > 0 && value <= this.$store.state.n_max_expuestos) {
        this.msg_expuestos = "";
        this.validador_expuestos = true;
      } else {
        this.validador_expuestos = false;
        this.msg_expuestos =
          "Debe ser menor o igual que " + this.$store.state.n_max_expuestos;
      }
    },

    limitText(count) {
      return `Y ${count} mas`;
    },

    fecha_hoy() {
      var n = new Date();
      // AÑO
      var y = n.getFullYear();
      // MES
      var m = n.getMonth() + 1;
      // DÍA
      var d = n.getDate();

      // ORDENAR
      this.fecha_actual = d + "/" + m + "/" + y;
    },

    agregar_nuevo_efecto(newTag) {
      this.check_efecto_posible.push(newTag);
      this.e_efecto_posible.push(newTag);
    },

    agregar_fuente(newTag) {
      this.select_fuente.push(newTag);
      this.control_fuente.push(newTag);
    },

    agregar_medio(newTag) {
      this.select_medio.push(newTag);
      this.control_medio.push(newTag);
    },

    agregar_individuo(newTag) {
      this.select_individuo.push(newTag);
      this.control_individuo.push(newTag);
    },

    // FUNCIÓN CARGAR PELIGRO
    cargar_peligros() {
      this.peligros = [];
      // CARGAR PELIGRO
      db.collection("nuevo_peligro")
        .where("p_registrado_por", "==", this.$store.state.email)
        .orderBy("p_nuevo_peligro", "asc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (`${doc.data().p_nuevo_peligro}` != "") {
              this.peligros.push(
                // MOSTRAR DATOS DE PELIGRO
                `${doc.data().p_nuevo_peligro}`
              );
            }
          });
        });
    },

    // FUNCIÓN CONSULTAR PELIGRO
    consultar_peligro() {
      this.select_fuente = [];
      this.select_medio = [];
      this.select_individuo = [];
      this.e_efecto_posible = [];
      this.check_efecto_posible = [];
      if (this.clasificacion_peligro == "") {
        this.p_id_peligro = "";
      }
      db.collection("nuevo_peligro")
        .where("p_nuevo_peligro", "==", this.clasificacion_peligro)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.p_id_peligro = `${doc.id}`;
            this.cargar_subclasificacion(`${doc.id}`);
          });
        })
        .catch((error) =>
          console.log("Error al consultar los peligros: ", error)
        );
    },

    // SUBCLASIFICACIÓN //

    // FUNCIÓN CARGAR SUBCLASIFICACIÓN
    cargar_subclasificacion(id_peligro) {
      this.subclasificacion = [];
      db.collection("nuevo_subclasificacion")
        .where("p_id_peligro", "==", id_peligro)
        .where("p_registrado_por", "==", this.$store.state.email)
        .orderBy("p_nuevo_subclasificacion", "asc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // MOSTRAR DATOS DE SUBCLASIFICACIÓN
            this.subclasificacion.push(
              `${doc.data().p_nuevo_subclasificacion}`
            );
          });
        });
    },

    // FUNCIÓN CONSULTAR SUBCLASIFICACIÓN
    consultar_subclasificacion() {
      if (this.subcla_selec === "") {
        this.p_id_subcla = "";
      }
      db.collection("nuevo_subclasificacion")
        .where("p_nuevo_subclasificacion", "==", this.subcla_selec)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.p_id_subcla = `${doc.id}`;
            this.cargar_fuente(`${doc.data().p_id_peligro}`, `${doc.id}`);
            this.cargar_medio(`${doc.data().p_id_peligro}`, `${doc.id}`);
            this.cargar_individuo(`${doc.data().p_id_peligro}`, `${doc.id}`);
            this.cargar_efectos_posibles(
              `${doc.data().p_id_peligro}`,
              `${doc.id}`
            );
          });
        })
        .catch((error) =>
          console.log("Error al consultar las subclasificaciones: ", error)
        );
    },

    // FUNCIÓN CARGAR CONTROL FUENTE
    async cargar_fuente(id_peligro, id_subclasificacion) {
      // CARGAR CONTROL
      this.control_fuente = [];

      await db
        .collection("nuevo_control_medida")
        .where("cm_id_peligro", "==", id_peligro)
        .where("cm_id_subcla", "==", id_subclasificacion)
        .where("cm_control_existente", "==", "Fuente")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.control_fuente.push(`${doc.data().cm_control_medida}`);
          });
        })
        .catch((error) => {
          console.log("Error obteniendo los controles fuente:", error);
        });
      if (this.$store.state.global_es_editar) {
        this.control_fuente = this.control_fuente.concat(this.select_fuente);
      }
    },

    // FUNCIÓN CARGAR CONTROL MEDIO
    async cargar_medio(id_peligro, id_subclasificacion) {
      // CARGAR CONTROL
      this.control_medio = [];
      await db
        .collection("nuevo_control_medida")
        .where("cm_id_peligro", "==", id_peligro)
        .where("cm_id_subcla", "==", id_subclasificacion)
        .where("cm_control_existente", "==", "Medio")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.control_medio.push(`${doc.data().cm_control_medida}`);
          });
        });
      if (this.$store.state.global_es_editar) {
        this.control_medio = this.control_medio.concat(this.select_medio);
      }
    },

    // FUNCIÓN CARGAR CONTROL INDIVIDUO
    async cargar_individuo(id_peligro, id_subclasificacion) {
      // CARGAR CONTROL
      this.control_individuo = [];
      await db
        .collection("nuevo_control_medida")
        .where("cm_id_peligro", "==", id_peligro)
        .where("cm_id_subcla", "==", id_subclasificacion)
        .where("cm_control_existente", "==", "Individuo")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.control_individuo.push(`${doc.data().cm_control_medida}`);
          });
        });
      if (this.$store.state.global_es_editar) {
        this.control_individuo = this.control_individuo.concat(
          this.select_individuo
        );
      }
    },

    // CARGAR COLECCIÓN nuevo_efecto_posible
    async cargar_efectos_posibles(id_peligro, id_subcla) {
      await db
        .collection("nuevo_efecto_posible")
        .where("e_id_peligro", "==", id_peligro)
        .where("e_id_subcla", "==", id_subcla)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.id_efectos_posibles = `${doc.id}`;
            this.e_efecto_posible = doc.data().e_efecto_posible;
            this.nombre_efecto_posible = `${doc.data().e_peligro}`;
          });
        });
      if (this.$store.state.global_es_editar) {
        this.e_efecto_posible = this.e_efecto_posible.concat(
          this.check_efecto_posible
        );
      }
    },

    // IMG BASE64
    base64Imagen1(file) {
      let canvas = document.getElementById("canvas");
      let ctx = canvas.getContext("2d");
      let cw = canvas.width;
      let ch = canvas.height;
      let maxW = 720;
      let maxH = 480;
      let img = new Image();
      img.onload = () => {
        let iw = img.width;
        let ih = img.height;
        let scale = Math.min(maxW / iw, maxH / ih);
        let iwScaled = iw * scale;
        let ihScaled = ih * scale;
        canvas.width = iwScaled;
        canvas.height = ihScaled;
        ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
        this.img_peligro = canvas.toDataURL("image/jpeg", 0.5);
        Swal.fire({
          icon: "success",
          title: "Imagen cargada correctamente :)",
          showConfirmButton: false,
          timer: 1500,
        });
      };
      img.src = URL.createObjectURL(file);
    },

    // IMG BASE64
    base64Imagen2(file) {
      let canvas = document.getElementById("canvas");
      let ctx = canvas.getContext("2d");
      let cw = canvas.width;
      let ch = canvas.height;
      let maxW = 720;
      let maxH = 480;
      let img = new Image();
      img.onload = () => {
        let iw = img.width;
        let ih = img.height;
        let scale = Math.min(maxW / iw, maxH / ih);
        let iwScaled = iw * scale;
        let ihScaled = ih * scale;
        canvas.width = iwScaled;
        canvas.height = ihScaled;
        ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
        this.img_peligro2 = canvas.toDataURL("image/jpeg", 0.5);
        Swal.fire({
          icon: "success",
          title: "Imagen cargada correctamente :)",
          showConfirmButton: false,
          timer: 1500,
        });
      };
      img.src = URL.createObjectURL(file);
    },

    async accion_formulario() {
      await NProgress.start();
      if (this.es_guardar == true) {
        if (this.$store.state.global_id_matriz_riesgo) {
          this.guardar_peligro();
        }
      } else {
        this.limpiar_variables();
        this.limpiar_variables_globales();
        this.$store.state.global_id_matriz_riesgo = "";
        this.$store.state.global_es_editar = false;
        this.$store.state.global_nuevo_peligro = false;
        NProgress.done();
        NProgress.remove();
      }
    },

    // GUARDAR PELIGRO
    async guardar_peligro() {
      if (this.$store.state.global_nuevo_peligro) {
        await this.guardar_nuevo_peligro();
        if (this.siguiente_peligro == true) {
          this.$store.state.global_id_matriz_riesgo = await db
            .collection("matriz_riesgo")
            .doc().id;
          this.$store.state.global_nuevo_peligro = true;
          this.siguiente_peligro = false;
        } else {
          await this.limpiar_variables_globales();
          this.$store.state.global_es_editar = true;
          this.redirigir();
        }
      } else {
        let em_requisito_legal = false;
        if (this.requisito_legal == "true") {
          em_requisito_legal = true;
        }
        if (
          this.img_peligro == "" ||
          this.img_peligro == "undefined" ||
          this.img_peligro == undefined
        ) {
          this.img_peligro = "";
        }
        if (
          this.img_peligro2 == "" ||
          this.img_peligro2 == "undefined" ||
          this.img_peligro2 == undefined
        ) {
          this.img_peligro2 = "";
        }
        db.collection("matriz_riesgo")
          .doc(this.$store.state.global_id_matriz_riesgo)
          .set(
            {
              em_id_peligro: this.p_id_peligro,
              em_id_subclasificacion: this.p_id_subcla,
              em_id_efectos_posibles: this.id_efectos_posibles,

              em_clasificacion: this.clasificacion_peligro,
              em_tipo: this.subcla_selec,
              em_descripcion: this.descripcion,

              em_efecto_posible: this.check_efecto_posible,
              em_c_fuente: this.select_fuente,
              em_c_medio: this.select_medio,
              em_c_individuo: this.select_individuo,
              em_antecedente: this.antecedente,
              em_requisito_legal: em_requisito_legal,

              // CORREGIR SI LA IMAGEN ESTÁ VACÍA
              em_img_peligro: this.img_peligro,
              em_img_peligro2: this.img_peligro2,

              // CRITERIOS CONTROLES
              em_num_expuestos: this.c_num_expuestos,
              em_peor_consecuencia: this.c_peor_consecuencia,
            },
            { merge: true }
          );

        NProgress.done();
        NProgress.remove();
        await this.limpiar_variables();
        await this.limpiar_variables_globales();
        if (this.siguiente_peligro) {
          // PERMITIR CREAR OTRO - otra id_matriz
          this.precrear_peligro();
        } else {
          this.redirigir();
        }
      }
    },

    async precrear_peligro() {
      this.siguiente_peligro = false;
      const antiguoIdMatriz = this.$store.state.global_id_matriz_riesgo;
      const docRef = db.collection("matriz_riesgo").doc(antiguoIdMatriz);

      this.$store.state.global_id_matriz_riesgo = db
        .collection("matriz_riesgo")
        .doc().id;

      await docRef
        .get()
        .then((doc) => {
          this.$store.state.mip_id_proceso = doc.data().em_id_proceso;
          this.$store.state.mip_id_zona = doc.data().em_id_zona;
          this.$store.state.mip_id_actividad = doc.data().em_id_acti;
          this.$store.state.mip_id_tareas = doc.data().em_id_tareas;

          this.$store.state.mip_proceso = doc.data().em_proceso;
          this.$store.state.mip_zona = doc.data().em_zona;
          this.$store.state.mip_actividad = doc.data().em_actividad;
          this.$store.state.mip_tarea = doc.data().em_tarea;
          this.$store.state.mip_rutinario = doc.data().em_rutinario;

          this.$store.state.global_nuevo_peligro = true;
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },

    async guardar_nuevo_peligro() {
      let em_requisito_legal = false;
      if (this.requisito_legal == "true") {
        em_requisito_legal = true;
      }
      await db
        .collection("matriz_riesgo")
        .doc(this.$store.state.global_id_matriz_riesgo)
        .set({
          em_id_cliente_iper: this.$store.state.msp_c_key_cliente_iper,
          em_id_cliente: this.$store.state.msp_c_key,

          em_id_proceso: this.$store.state.mip_id_proceso,
          em_id_zona: this.$store.state.mip_id_zona,
          em_id_acti: this.$store.state.mip_id_actividad,
          em_id_tareas: this.$store.state.mip_id_tareas,

          em_fecha_registro: firebase.firestore.FieldValue.serverTimestamp(),
          em_fecha_editado: firebase.firestore.FieldValue.serverTimestamp(),

          em_proceso: this.$store.state.mip_proceso,
          em_zona: this.$store.state.mip_zona,
          em_actividad: this.$store.state.mip_actividad,
          em_tarea: this.$store.state.mip_tarea,
          em_rutinario: this.$store.state.mip_rutinario,

          em_id_peligro: this.p_id_peligro,
          em_id_subclasificacion: this.p_id_subcla,
          em_id_efectos_posibles: this.id_efectos_posibles,

          em_clasificacion: this.clasificacion_peligro,
          em_tipo: this.subcla_selec,
          em_descripcion: this.descripcion,

          em_efecto_posible: this.check_efecto_posible,
          em_c_fuente: this.select_fuente,
          em_c_medio: this.select_medio,
          em_c_individuo: this.select_individuo,
          em_antecedente: this.antecedente,
          em_requisito_legal: em_requisito_legal,

          em_img_peligro: this.img_peligro,
          em_img_peligro2: this.img_peligro2,

          em_nivel_eficiencia: "",
          em_nivel_exposicion: "",
          em_nivel_probabilidad: "",
          em_interpretacion: "",
          em_nivel_consecuencia: "",
          em_nivel_riesgo: "",
          em_interpretacion_nr: "",
          em_aceptabilidad: "",

          em_num_expuestos: this.c_num_expuestos,
          em_peor_consecuencia: this.c_peor_consecuencia,

          em_eliminacion: [],
          em_sustitucion: [],
          em_controles_ing: [],
          em_controles: [],
          em_equipos: [],
        })
        .then(() => {
          this.$store.state.global_nuevo_peligro = false;
          this.limpiar_variables();
          NProgress.done();
          NProgress.remove();
        })
        .catch((error) => {
          console.error("Error al crear nuevo peligro: ", error);
        });
    },

    // FUNCIÓN QUE LIMPIA LA MAYORIA DE LAS VARIABLES
    limpiar_variables() {
      this.id_matriz = "";
      this.$store.state.msp_es_proceso = false;
      this.id_efectos_posibles = "";
      this.p_id_peligro = "";
      this.p_id_subcla = "";
      this.clasificacion_peligro = "";
      this.subcla_selec = "";
      this.descripcion = "";
      this.check_efecto_posible = [];
      this.select_fuente = [];
      this.select_medio = [];
      this.select_individuo = [];
      this.antecedente = "";
      this.requisito_legal = "";
      this.img_peligro = [];
      this.img_peligro2 = [];
      this.efecto_posible_descripcion = "";
      this.e_efecto_posible = [];
      this.c_num_expuestos = null;
      this.c_peor_consecuencia = "";
      this.es_guardar = false;
      this.msg_expuestos = "";
      this.validador_expuestos = false;
    },

    async limpiar_variables_globales() {
      this.$store.state.mip_id_proceso = "";
      this.$store.state.mip_id_zona = "";
      this.$store.state.mip_id_actividad = "";
      this.$store.state.mip_id_tareas = "";
      this.$store.state.mip_proceso = "";
      this.$store.state.mip_zona = "";
      this.$store.state.mip_actividad = "";
      this.$store.state.mip_tarea = [];
      this.$store.state.mip_rutinario = "";
    },

    redirigir() {
      const tap1 = document.querySelector("#mip-tab");
      tap1.classList.remove("active");
      tap1.setAttribute("aria-selected", false);

      const tap2 = document.getElementById("mer-tab");
      tap2.setAttribute("aria-selected", true);
      this.$router.push("/evaluacion_riesgos");
    },
  },
  computed: {
    // SELECCIONAR TODOS LOS CHECKBOX DE EFECTOS POSIBLES
    selectTodo: {
      get() {
        return this.e_efecto_posible
          ? this.check_efecto_posible.length == this.e_efecto_posible.length
          : false;
      },
      set(value) {
        var check_efecto_posible = [];

        if (value) {
          this.e_efecto_posible.forEach((e_efecto_posible) => {
            check_efecto_posible.push(e_efecto_posible);
          });
        }
        this.check_efecto_posible = check_efecto_posible;

        let set = new Set(this.check_efecto_posible.map(JSON.stringify));
        this.check_efecto_posible = Array.from(set).map(JSON.parse);
      },
    },
  },
};
</script>